export default __webpack_public_path__ + "static/media/Giza_blanco_1.d5a55f06.png";